import { combineReducers } from 'redux';

import providerLocations from './requests/provider-locations-req';
import providerServices from './requests/provider-services-req';
import intersections from './requests/intersection-counts-req';
import practiceProviders from './requests/practice-providers-req';
import workslotInsert from './requests/workslot-insert-req';
import workslotRemove from './requests/workslot-remove-req';
import blockslotInsert from './requests/blockslot-insert-req';
import blockslotRemove from './requests/blockslot-remove-req';
import blockslotUpdate from './requests/blockslot-update-req';
import scheduleList from './requests/schedule-search-req';
import patientTypes from './requests/patient-type-req';
import workslotUpdate from './requests/workslot-update-req';
import createAppointment from './requests/create-apppointment-req';
import inspectAppointment from './requests/appointment-inspector-req';
import patientList from './requests/patients-by-provider-req';
import visitTypes from './requests/visit-type-by-location-req';
import scheduleDefaults from './requests/schedule-defaults-req';
import appointmentGuard from './appointmentGuard';
import selectedPopover from './selectedPopover';
import validate from './validate';
import filter from './filter';

export default combineReducers({
  providerLocations,
  providerServices,
  intersections,
  practiceProviders,
  workslotInsert,
  workslotRemove,
  workslotUpdate,
  blockslotInsert,
  blockslotRemove,
  blockslotUpdate,
  createAppointment,
  inspectAppointment,
  patientList,
  visitTypes,
  scheduleDefaults,
  patientTypes,
  scheduleList,
  selectedPopover,
  appointmentGuard,
  validate,
  filter,
});



// WEBPACK FOOTER //
// ./src/redux/schedule/index.js